(()=>{
  
  injectCSS();
  addSubtotalToCheckoutButton();
  updateCartItemsTotalEveryTimeItChanges();
  floatCheckoutButton();

  function floatCheckoutButton() {
    let button = document.querySelector('#checkout');
    let boxElement = document.querySelector('#cart .additional-checkout-buttons');
    let prevRatio = 0.0;
    let observer;
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.0,
    };

    observer = new IntersectionObserver(handleIntersect, options);
    observer.observe(boxElement);

    function handleIntersect(entries, observer) {
      entries.forEach((entry) => {
        if ( entry.isIntersecting ) {
          button.classList.remove('jci-floating');
        } else if (entry.boundingClientRect.top >= 0) {
          button.classList.add('jci-floating');
        }
        console.log(entry.boundingClientRect.y);
        prevRatio = entry.intersectionRatio;
      });
    }
  }

  function addSubtotalToCheckoutButton() {
    const button = document.querySelector('#checkout');
    const total = document.querySelector('#cart .js-contents-foot [data-price]').textContent;
    button.querySelector('.button__text').insertAdjacentHTML('afterend', `<span class="jci-checkout-total" data-text-content="cart-items-total">${total}</span>`);
  }

  function updateCartItemsTotalEveryTimeItChanges() {
    const targetNode = document.querySelector('#cart-items-footer .js-contents-foot');
    const config = { childList: true, subtree: true };
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType == 1 && node.matches('.cart-items__total')) {
            const total = node.querySelector('[data-price]').textContent;
            document.querySelectorAll('[data-text-content="cart-items-total"]')
              .forEach( el => {
                el.textContent = total;
              });
          } else {
            console.log (node);
          }
        });
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  function injectCSS() {

    var styleSheet = document.createElement("style");
    styleSheet.innerText = `
      #cart .js-contents-foot {
      }
      #checkout.jci-floating {
        position: fixed;
        bottom: 0;
        left: 2.4rem;
        right: 2.4rem;
        width: calc(100% - 2.4rem - 2.4rem);
        z-index: 2;
      }
      #checkout.jci-floating + .additional-checkout-buttons {
        margin-top: calc(48px + 11px);
      }

      #cart .jci-checkout-total {
        margin-left: .5em;
      }
    `;
    document.head.appendChild(styleSheet);
  }
})();
